import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import PositionedPopper from './PositionedPopper';
import ClientProvider from './client';
export default createDemo(import.meta.url, PositionedPopper, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/popper/demos/positioned/PositionedPopper.tsx",
    "fileName": "PositionedPopper.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Popper from '@mui/material/Popper';\nimport type { PopperPlacementType } from '@mui/material/Popper';\nimport Typography from '@mui/material/Typography';\nimport Stack from '@mui/material/Stack';\nimport Button from '@mui/material/Button';\nimport Fade from '@mui/material/Fade';\nimport Paper from '@mui/material/Paper';\n\nexport default function PositionedPopper() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);\n  const [open, setOpen] = React.useState(false);\n  const [placement, setPlacement] = React.useState<PopperPlacementType>();\n\n  const handleClick =\n    (newPlacement: PopperPlacementType) =>\n    (event: React.MouseEvent<HTMLButtonElement>) => {\n      setAnchorEl(event.currentTarget);\n      setOpen((prev) => placement !== newPlacement || !prev);\n      setPlacement(newPlacement);\n    };\n\n  return (\n    <Box sx={{ width: 500 }}>\n      <Popper\n        // Note: The following zIndex style is specifically for documentation purposes and may not be necessary in your application.\n        sx={{ zIndex: 1200 }}\n        open={open}\n        anchorEl={anchorEl}\n        placement={placement}\n        transition\n      >\n        {({ TransitionProps }) => (\n          <Fade {...TransitionProps} timeout={350}>\n            <Paper>\n              <Typography sx={{ p: 2 }}>The content of the Popper.</Typography>\n            </Paper>\n          </Fade>\n        )}\n      </Popper>\n      <Stack direction=\"row\" sx={{ justifyContent: 'center' }}>\n        <Button onClick={handleClick('top-start')}>top-start</Button>\n        <Button onClick={handleClick('top')}>top</Button>\n        <Button onClick={handleClick('top-end')}>top-end</Button>\n      </Stack>\n      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>\n        <Stack direction=\"column\" sx={{ alignItems: 'flex-start' }}>\n          <Button onClick={handleClick('left-start')}>left-start</Button>\n          <Button onClick={handleClick('left')}>left</Button>\n          <Button onClick={handleClick('left-end')}>left-end</Button>\n        </Stack>\n        <Stack direction=\"column\" sx={{ alignItems: 'flex-end' }}>\n          <Button onClick={handleClick('right-start')}>right-start</Button>\n          <Button onClick={handleClick('right')}>right</Button>\n          <Button onClick={handleClick('right-end')}>right-end</Button>\n        </Stack>\n      </Box>\n      <Stack direction=\"row\" sx={{ justifyContent: 'center' }}>\n        <Button onClick={handleClick('bottom-start')}>bottom-start</Button>\n        <Button onClick={handleClick('bottom')}>bottom</Button>\n        <Button onClick={handleClick('bottom-end')}>bottom-end</Button>\n      </Stack>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 66,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Popper from '@mui/material/Popper';\nimport type { PopperPlacementType } from '@mui/material/Popper';\nimport Typography from '@mui/material/Typography';\nimport Stack from '@mui/material/Stack';\nimport Button from '@mui/material/Button';\nimport Fade from '@mui/material/Fade';\nimport Paper from '@mui/material/Paper';\n\nexport default function PositionedPopper() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);\n  const [open, setOpen] = React.useState(false);\n  const [placement, setPlacement] = React.useState<PopperPlacementType>();\n\n  const handleClick =\n    (newPlacement: PopperPlacementType) =>\n    (event: React.MouseEvent<HTMLButtonElement>) => {\n      setAnchorEl(event.currentTarget);\n      setOpen((prev) => placement !== newPlacement || !prev);\n      setPlacement(newPlacement);\n    };\n\n  return (\n    <Box sx={{ width: 500 }}>\n      <Popper\n        // Note: The following zIndex style is specifically for documentation purposes and may not be necessary in your application.\n        sx={{ zIndex: 1200 }}\n        open={open}\n        anchorEl={anchorEl}\n        placement={placement}\n        transition\n      >\n        {({ TransitionProps }) => (\n          <Fade {...TransitionProps} timeout={350}>\n            <Paper>\n              <Typography sx={{ p: 2 }}>The content of the Popper.</Typography>\n            </Paper>\n          </Fade>\n        )}\n      </Popper>\n      <Stack direction=\"row\" sx={{ justifyContent: 'center' }}>\n        <Button onClick={handleClick('top-start')}>top-start</Button>\n        <Button onClick={handleClick('top')}>top</Button>\n        <Button onClick={handleClick('top-end')}>top-end</Button>\n      </Stack>\n      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>\n        <Stack direction=\"column\" sx={{ alignItems: 'flex-start' }}>\n          <Button onClick={handleClick('left-start')}>left-start</Button>\n          <Button onClick={handleClick('left')}>left</Button>\n          <Button onClick={handleClick('left-end')}>left-end</Button>\n        </Stack>\n        <Stack direction=\"column\" sx={{ alignItems: 'flex-end' }}>\n          <Button onClick={handleClick('right-start')}>right-start</Button>\n          <Button onClick={handleClick('right')}>right</Button>\n          <Button onClick={handleClick('right-end')}>right-end</Button>\n        </Stack>\n      </Box>\n      <Stack direction=\"row\" sx={{ justifyContent: 'center' }}>\n        <Button onClick={handleClick('bottom-start')}>bottom-start</Button>\n        <Button onClick={handleClick('bottom')}>bottom</Button>\n        <Button onClick={handleClick('bottom-end')}>bottom-end</Button>\n      </Stack>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 66,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Popper",
      "@mui/material/Typography",
      "@mui/material/Stack",
      "@mui/material/Button",
      "@mui/material/Fade",
      "@mui/material/Paper"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
